type valType = string | boolean | number
// The "object" here covers both arrays and regular objects
// We assign regular objects to the returned map in PrincipalsSignupSurvey.js
type mapType = Record<string, valType | object>;

export function serializeJQueryForm(elId: string) {
    const o: mapType = {};
    const a = $(elId).serializeArray();
    $.each(a, function () {
        let val: valType = this.value || '';
        if (val === 'on') {
            val = true;
        } else if (val === 'false' || val === 'true') {
            val = (val === 'true');
        } else if (Number.isInteger(val)) {
            val = parseInt(val);
        }
        setItem(o, this.name, val);
    });

    // note that checkbox off will be missing, so add this back
    const checkboxes = $(elId).find('input:checkbox:not(:checked)');
    for (let i = 0; i < checkboxes.length; i++) {
        const el = checkboxes[i] as HTMLInputElement;
        setItem(o, el.name, false);
    }

    return o;
}

function setItem(o: mapType, index: string, val: valType) {
    if (o[index] !== undefined) {
        if (!Array.isArray(o[index])) {
            o[index] = [o[index]];
        }
        (o[index] as valType[]).push(val);
    } else {
        o[index] = val;
    }
}
